









































































































































































































































import {
  ICouponDetails,
  ICouponList,
  IFilters,
  IUserData,
} from "@/vuex/modules/coupon/interfaces";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import DetailsCompetitor from "../components/DetailsCompetitor.vue";
import DetailsBudgetSou from "../components/DetailsBudgetSou.vue";
import DetailsCoupon from "../components/DetailsCoupon.vue";
import DetailsCouponAttached from "../components/DetailsCouponAttached.vue";

@Component({
  components: {
    DetailsCompetitor,
    DetailsBudgetSou,
    DetailsCoupon,
    DetailsCouponAttached,
  },
})
export default class DialogDetails extends Vue {
  @Prop(Object) coupon!: ICouponList;
  @Prop(Object) filters!: IFilters;

  @Getter("getPercentage", { namespace: "coupon" }) percentage!: number;
  @Getter("getUserInfo", { namespace: "coupon" }) user_info!: IUserData;

  @Action("getDetailsCoupon", { namespace: "coupon" }) getDetailsCoupon!: (
    couponId: number
  ) => Promise<ICouponDetails>;

  @Action("loadCoupons", { namespace: "coupon" }) loadCoupons!: (
    filters: IFilters
  ) => Promise<boolean>;

  @Action("putCoupon", { namespace: "coupon" }) putCoupon!: (update: {
    couponId: number;
    value: {
      discount: number;
      discount_value: number;
      discount_total: number;
      status: string;
      active: boolean;
    };
  }) => Promise<boolean>;

  overlay = true;
  edit = false;
  switchTypeValue = false;
  //eslint-disable-next-line
  newDiscountValue: any = "";
  newDiscountPerCent = 0;
  validDiscountValue = false;
  newValue = 0;
  couponDetails: ICouponDetails = {
    coupons_added: [],
    competition_budget_pdf: "",
    status: "",
    competitor: {
      name: "",
      brandInverter: "",
      powerInverter: "",
      amountInverter: "",
      powerPanel: "",
      brandPanel: "",
      amountPanel: "",
      powerSystem: "",
      valueBudget: "",
      wattValue: "",
      offer: "",
      pdfCompetitor: "",
      coverDiscount: "",
      valueRoof: "",
      typeStructure: "",
    },
    generated_id: 0,
    payment_type: "",
    coupon_type: "",
    budget_id: 0,
    budget_value: 0,
    discount: 0,
    discount_value: 0,
    discount_total: 0,
    initial_discount: 0,
    coupon_code: "Código",
    admin_id: 1,
    rca_id: 0,
    rule_id: 0,
    coupon_name: "Nome do CUpom",
    integrator_id: 0,
    description: "Descrição",
    integrator_trade: "teste",
    integrator_trade_name: "teste",
    integrator_name: "teste",
    active: false,
    max_discount: 0,
    value_equipment: 0,
    budget_sou: {
      id: 100128,
      generators: { type: "multi", brand: "Marca do Inversor" },
      discountsActive: 0,
      totalDiscount: 0,
      value: 0,
      transferValue: 0,
      equipamentValue: 0,
      idIntegrator: 0,
      integratorName: "teste",
      fantasyIntegratorName: "Nome Fantasia",
      reasonIntegratorName: "Razão Social",
      consultantName: "Nome do Consultor",
      discountMaxBrl: 0,
      couponsActive: [],
      discountMaxPercent: 0,
      amountInverters: 0,
      powerInverter: 0,
      brandInverter: "Marca do Inversor",
      brandPanel: "Marca do Painel",
      powerPanel: 0,
      amountPanel: 0,
      powerSystem: 0,
      typeStructure: "Tipo de Estrutura",
      deliveryLocale: "Local de entrega",
      inGroup: false
    },
    generator_type: "",
  };

  @Watch("switchTypeValue")
  onSwitchTypeValueChange(value: boolean): void {
    if (isNaN(this.newDiscountValue)) {
      this.newDiscountValue = 0;
    }
    if (value) {
      this.newDiscountValue = this.newValue;
    } else {
      this.newDiscountValue = (
        (this.newDiscountValue * 100) /
        this.couponDetails.budget_sou.equipamentValue
      ).toFixed(4);
    }
  }

  @Watch("newDiscountValue")
  onDiscountValueChange(): void {
    if (isNaN(this.newDiscountValue)) {
      return;
    }

    if (parseFloat(this.newDiscountValue) > 100 && !this.switchTypeValue) {
      this.newDiscountValue = 100;
    }
    if (!this.switchTypeValue) {
      this.newValue = parseFloat(
        (
          (this.newDiscountValue *
            this.couponDetails.budget_sou.discountMaxBrl) /
          this.couponDetails.budget_sou.discountMaxPercent
        ).toFixed(2)
      );
      this.newDiscountPerCent = this.newDiscountValue;
    } else {
      this.newDiscountPerCent = parseFloat(
        (
          (this.newDiscountValue * 100) /
          this.couponDetails.budget_sou.equipamentValue
        ).toFixed(4)
      );
      this.newValue = parseFloat(this.newDiscountValue);
    }

    if (isNaN(this.newValue)) {
      this.newValue = 0;
    }
    if (this.newDiscountPerCent > this.percentage) {
      this.validDiscountValue = true;
    } else {
      this.validDiscountValue = false;
    }
  }

  public updateCoupon(value: {
    discount: number;
    discount_value: number;
    discount_total: number,
    status: string;
    active: boolean;
  }): void {
    this.overlay = true;
    this.putCoupon({
      couponId: this.couponDetails.generated_id,
      value: value,
    }).then((response) => {
      if (response) {
        this.getDetailsCoupon(this.coupon.generated_id).then((response) => {
          this.couponDetails = response;
          this.newDiscountValue = response.discount;
          this.newDiscountPerCent = response.discount;
          this.newValue = response.discount_value;
          this.loadCoupons(this.filters).then(() => {
            this.overlay = false;
          });
        });
      }
    });
  }

  async mounted(): Promise<void> {
    await this.getDetailsCoupon(this.coupon.generated_id).then((response) => {
      this.couponDetails.budget_sou.discountMaxPercent = this.percentage;
      this.couponDetails.budget_sou.discountMaxBrl =
        (this.couponDetails.value_equipment * this.percentage) / 100;
      this.couponDetails = response;
      this.newDiscountValue = response.discount;
      this.newDiscountPerCent = response.discount;
      this.newValue = response.discount_value;
      this.overlay = false;
    });
  }

  public formatDiscount(): void {
    const stringDiscount = this.newDiscountValue.toString();
    this.newDiscountValue = stringDiscount.replace(
      /[a-zA-Z\u00C0-\u00FF!@#+$%¨&*()/{}[/\]|`´^~;:?ªº§=°', "]+/i,
      ""
    );
  }

  public showEdit(): void {
    this.edit = true;
  }

  public closeDialog(): void {
    this.coupon.dialog = false;
  }

  public isUserSupCorridaOuro(): boolean{
    if(this.couponDetails.budget_sou.inGroup){
      if (this.user_info.role == 6) {
       return false;
      }else{
        return true;
      }
    }else{
      return true;
    }
  }
}
